import { useMemo } from "react";

// Bar colour cycle from the Calm Shell source: mostly plum, with lavender,
// coral and butter as sparse accents — never a single flat colour.
const COLOURS = [
  "var(--accent)", "var(--accent)", "#9C8FEA", "var(--accent)", "#FF7A6B",
  "var(--accent)", "#9C8FEA", "var(--accent)", "#FFC94D", "var(--accent)", "#9C8FEA",
];

// Centre-anchored voice waveform — shared by LiveSession and DemoSession so both
// voice-first screens render identically (no written question, no dark background).
export function Waveform({ active }: { active: boolean }) {
  const bars = useMemo(() => Array.from({ length: 40 }, (_, i) => i), []);
  return (
    <div className="flex h-24 items-center justify-center gap-[3px]" aria-hidden="true">
      <style>{`@keyframes wave{0%,100%{transform:scaleY(0.35)}50%{transform:scaleY(1)}}`}</style>
      {bars.map((i) => (
        <span
          key={i}
          className="w-[3px] rounded-full"
          style={{
            background: active ? COLOURS[i % COLOURS.length] : "var(--accent)",
            height: active ? "100%" : "18%",
            transformOrigin: "center",
            animation: active ? `wave 1.1s ease-in-out ${(i % 11) * 0.07}s infinite` : "none",
            opacity: active ? 0.9 : 0.35,
            transition: "height .3s, opacity .3s",
          }}
        />
      ))}
    </div>
  );
}
